import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarShow18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.4697 8.46968L13.5303 9.53034L17.0607 6.00001L13.5303 2.46968L12.4697 3.53034L14.9393 6.00001L12.4697 8.46968Z'
      fill='currentColor'
    />
    <path d='M1 4.75001H10V3.25001H1V4.75001Z' fill='currentColor' />
    <path d='M1 9.75001H10V8.25001H1V9.75001Z' fill='currentColor' />
    <path d='M17 14.75H1V13.25H17V14.75Z' fill='currentColor' />
  </Svg>
);

SidebarShow18.displayName = 'SidebarShow18';
export default SidebarShow18;
